import _ from 'lodash';
import React from 'react';
import { Icon } from '../icon';
export const renderAccordionIcon = (actionIcon) => {
    if (!_.isEmpty(actionIcon)) {
        return React.createElement(Icon, { ...actionIcon });
    }
    return React.createElement(React.Fragment, null);
};
//# sourceMappingURL=accordion-icon-util.js.map